module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/christmas_desktop-73dbca9f7529b85f1519ac6464d2c34c.png";